import ReCAPTCHA from 'react-google-recaptcha';
import { createPortal } from 'react-dom';
import css from './index.module.scss';
import { submitQuotation } from './service';
import Success from './Success';
import { useGlobal } from '@/utils/useGlobal';
import { rpcMap } from '@/constants/lang';
import Uploader from '@elem/compCommon/Uploader';
import Dialog from './Dialog';

// ONLY FOR DP3 JP
export default function QuoteForm() {
    const { useState, useRouter, useEffect, useLang, useRef } = useGlobal();
    const { t } = useLang('dp3.crowdfunding.quote_form');
    const { locale } = useRouter();
    const [selectOpen, setSelectOpen] = useState(false);
    const [selectOpen2, setSelectOpen2] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const recaptchaRef = useRef();
    const hl = rpcMap[locale];
    const SECRET_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_REGISTER_SECRET_KEY;

    const initObj = {
        hiragana: '',
        katakana: '',
        purchased: false,
        orderNumber: '',
        zipCode: '',
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        email: '',
        emailConfirm: '',
        phone: '',
        connectionMethod: '',
        img: [],
        content: '',
        agreed: false,
        recaptchaResponse: '',
    };

    const [formData, setFormData] = useState(initObj);

    const [tipObj, setTipObj] = useState({});

    const icon = (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <g clipPath="url(#clip0_4893_954)">
                <path
                    d="M6.14966 3L6.46258 7.78185H7.53742L7.85034 3H6.14966ZM6.9932 8.94459C6.72109 8.94459 6.4898 9.0285 6.29932 9.22431C6.09524 9.40613 6 9.64389 6 9.9376C6 10.2173 6.09524 10.4551 6.29932 10.6509C6.4898 10.8467 6.72109 10.9446 6.9932 10.9446C7.26531 10.9446 7.5102 10.8467 7.71429 10.6649C7.90476 10.4691 8 10.2313 8 9.9376C8 9.64389 7.90476 9.40613 7.71429 9.22431C7.52381 9.0285 7.27891 8.94459 6.9932 8.94459Z"
                    fill="#F8200C"
                />
                <path
                    d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
                    stroke="#F8200C"
                />
            </g>
            <defs>
                <clipPath id="clip0_4893_954">
                    <rect width="14" height="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );

    const handleInputChange = (e: any, id: string) => {
        const value = e.target.value;
        if (
            ['hiragana', 'katakana', 'orderNumber', 'zipCode', 'address1', 'address2', 'address3', 'email', 'emailConfirm', 'phone'].includes(id) &&
            value.length > 50
        ) {
            return;
        }
        if (id === 'address4' && value.length > 100) {
            return;
        }
        if (id === 'content' && value.length > 200) {
            return;
        }
        setFormData({ ...formData, [id]: value });
    };

    const handleInputFocus = (id: string) => {
        if (tipObj[id]) {
            setTipObj({ ...tipObj, [id]: false });
        }
    };

    const handleToggleSelect = () => {
        setSelectOpen(!selectOpen);
        if (tipObj?.purchased && !selectOpen) {
            setTipObj({ ...tipObj, purchased: false });
        }
    };
    const handleToggleSelectContact = () => {
        setSelectOpen2(!selectOpen2);
        if (tipObj?.contactType && !selectOpen2) {
            setTipObj({ ...tipObj, contactType: false });
        }
    };

    const handleSelect = (value: string) => {
        setFormData({ ...formData, purchased: value });
    };
    const handleSelect2 = (value: string) => {
        setFormData({ ...formData, contactType: value });
    };

    const handleChangeRadio = (n: string) => {
        setFormData({ ...formData, connectionMethod: n });
        if (tipObj?.connectionMethod) {
            setTipObj({ ...tipObj, connectionMethod: false });
        }
    };

    const handleCheckChange = (e: any) => {
        setFormData({ ...formData, agreed: e.target.checked });
        if (tipObj?.agreed && e.target.checked) {
            setTipObj({ ...tipObj, agreed: false });
        }
    };

    const onReCAPTCHAChange = async (recaptchaResponse: string) => {
        if (!recaptchaResponse) {
            return;
        }
        setFormData({ ...formData, recaptchaResponse });
    };

    const valiEmail = (obj: any) => {
        const emailRegex = /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (formData.email) {
            if (!emailRegex.test(formData.email)) {
                obj.email = 1;
            }
        }
        if (formData.emailConfirm) {
            if (!emailRegex.test(formData.emailConfirm)) {
                obj.emailConfirm = 1;
            } else {
                if (formData.email.trim() !== formData.emailConfirm.trim()) {
                    obj.emailConfirm = 2;
                }
            }
        }
    };

    const valiPhoneZip = (obj: any) => {
        // 日本邮编7位
        const zipRegex = /^\d{7}$/;
        if (formData.zipCode && !zipRegex.test(Number(formData.zipCode))) {
            obj.zipCode = 1;
        }
        const phoneRegex = /^\d{9,11}$/;
        if (formData.phone && !phoneRegex.test(Number(formData.phone))) {
            obj.phone = 1;
        }
    };

    const handleSubmit = async () => {
        const {
            hiragana,
            katakana,
            purchased,
            contactType,
            orderNumber = '',
            zipCode,
            address1,
            address2,
            address3,
            address4 = '',
            email,
            emailConfirm,
            phone,
            connectionMethod = '',
            img = [],
            content,
            agreed,
            recaptchaResponse,
        } = formData;
        const obj = {
            hiragana: !Boolean(hiragana),
            katakana: !Boolean(katakana),
            purchased: !Boolean(purchased),
            contactType: !Boolean(contactType),
            zipCode: !Boolean(zipCode),
            address1: !Boolean(address1),
            address2: !Boolean(address2),
            address3: !Boolean(address3),
            email: !Boolean(email),
            emailConfirm: !Boolean(emailConfirm),
            phone: !Boolean(phone),
            content: !Boolean(content),
            connectionMethod: !Boolean(connectionMethod),
            agreed: !Boolean(agreed),
        };
        if (Object.values(obj)?.some((value: boolean) => value === true)) {
            valiEmail(obj);
            valiPhoneZip(obj);
            setTipObj(obj);
            return;
        } else {
            valiEmail(obj);
            valiPhoneZip(obj);
            setTipObj(obj);
            if (obj.email || obj.emailConfirm || obj.phone || obj.zipCode) {
                return;
            }
            // const recaptchaRes = await recaptchaRef.current.execute();
            // setFormData({ ...formData, recaptchaResponse: recaptchaRes });

            const data = {
                hiragana,
                katakana,
                purchased: Boolean(formData.purchased === t('buy_answer1')),
                contactType: formData.contactType === t('contactType_answer1') ? 1 : 2,
                orderNumber,
                zipCode,
                address1,
                address2,
                address3,
                address4,
                email: email.trim(),
                phone,
                connectionMethod,
                img: img?.[0] || '',
                content,
                agreed,
                recaptchaResponse,
            };
            const res = await submitQuotation(data, locale);
            if (res?.code === '0') {
                setShowSuccess(true);
                setFormData(initObj);
            } else {
                console.error(res?.message);
            }
        }
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <div className={`quote-form ${css['quote-form']}`}>
            <div className="form-info">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
            </div>
            <div className="form">
                <ul className="form-lists">
                    <li className="list short required">
                        <input
                            className={`input ${tipObj?.hiragana ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('name')}*`}
                            value={formData?.hiragana}
                            onChange={(e: any) => handleInputChange(e, 'hiragana')}
                            onFocus={() => handleInputFocus('hiragana')}
                        />
                        {tipObj?.hiragana && (
                            <p className="msg">
                                {icon}
                                {t('name_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list short required">
                        <input
                            className={`input ${tipObj?.katakana ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('furigana')}*`}
                            value={formData?.katakana}
                            onChange={(e: any) => handleInputChange(e, 'katakana')}
                            onFocus={() => handleInputFocus('katakana')}
                        />
                        {tipObj?.katakana && (
                            <p className="msg">
                                {icon}
                                {t('furigana_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list required">
                        <div className={`input selection ${tipObj?.purchased ? 'error' : ''} `} onClick={handleToggleSelect}>
                            <p className={`select-value ${formData?.purchased ? '' : 'placeholder'}`}>
                                {formData?.purchased ? formData?.purchased : `${t('buy')}*`}
                            </p>
                            <svg
                                className={`select-svg ${selectOpen ? 'open' : 'close'}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                            >
                                <path
                                    d="M2.46143 10.7564L7.79476 5.42306L13.1281 10.7564"
                                    stroke="#949494"
                                    strokeWidth="1.4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {selectOpen && (
                                <ul className="selection">
                                    <li className="option" onClick={() => handleSelect(t('buy_answer1'))}>
                                        {t('buy_answer1')}
                                    </li>
                                    <li className="option" onClick={() => handleSelect(t('buy_answer2'))}>
                                        {t('buy_answer2')}
                                    </li>
                                </ul>
                            )}
                        </div>
                        {tipObj?.purchased && (
                            <p className="msg">
                                {icon}
                                {t('buy_tip')}
                            </p>
                        )}
                    </li>
                    {formData?.purchased === t('buy_answer1') && (
                        <li className={`list`}>
                            <input
                                className="input"
                                type="text"
                                placeholder={t('order_number')}
                                value={formData?.orderNumber}
                                onChange={(e: any) => handleInputChange(e, 'orderNumber')}
                                onFocus={() => handleInputFocus('orderNumber')}
                            />
                        </li>
                    )}

                    <li className="list required">
                        <input
                            className={`input ${tipObj?.email ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('email')}*`}
                            value={formData?.email}
                            onChange={(e: any) => handleInputChange(e, 'email')}
                            onFocus={() => handleInputFocus('email')}
                        />
                        {tipObj?.email && (
                            <p className="msg">
                                {icon}
                                {tipObj?.email === 1 ? t('email_error') : t('email_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list required">
                        <input
                            className={`input ${tipObj?.emailConfirm ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('email_confirm')}*`}
                            value={formData?.emailConfirm}
                            onChange={(e: any) => handleInputChange(e, 'emailConfirm')}
                            onFocus={() => handleInputFocus('emailConfirm')}
                        />
                        {tipObj?.emailConfirm && (
                            <p className="msg">
                                {icon}
                                {tipObj?.emailConfirm === 1 ? t('email_error') : tipObj?.emailConfirm === 2 ? t('email_notsame') : t('email_confirm_tip')}
                            </p>
                        )}
                    </li>

                    <li className="list required">
                        <input
                            className={`input ${tipObj?.phone ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('phone')}*`}
                            value={formData?.phone}
                            onChange={(e: any) => handleInputChange(e, 'phone')}
                            onFocus={() => handleInputFocus('phone')}
                        />
                        {tipObj?.phone && (
                            <p className="msg">
                                {icon}
                                {tipObj?.phone === 1 ? t('phone_error') : t('phone_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list required">
                        <div className={`input selection ${tipObj?.contactType ? 'error' : ''} `} onClick={handleToggleSelectContact}>
                            <p className={`select-value ${formData?.contactType ? '' : 'placeholder'}`}>
                                {formData?.contactType ? formData?.contactType : `${t('contactType')}*`}
                            </p>
                            <svg
                                className={`select-svg ${selectOpen2 ? 'open' : 'close'}`}
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                            >
                                <path
                                    d="M2.46143 10.7564L7.79476 5.42306L13.1281 10.7564"
                                    stroke="#949494"
                                    strokeWidth="1.4"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            {selectOpen2 && (
                                <ul className="selection">
                                    <li className="option" onClick={() => handleSelect2(t('contactType_answer1'))}>
                                        {t('contactType_answer1')}
                                    </li>
                                    <li className="option" onClick={() => handleSelect2(t('contactType_answer2'))}>
                                        {t('contactType_answer2')}
                                    </li>
                                </ul>
                            )}
                        </div>
                        {tipObj?.contactType && (
                            <p className="msg">
                                {icon}
                                {t('contactType_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list list-title">{t('address')}</li>
                    <li className="list short required">
                        <input
                            className={`input ${tipObj?.zipCode ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('zip')}*`}
                            value={formData?.zipCode}
                            onChange={(e: any) => handleInputChange(e, 'zipCode')}
                            onFocus={() => handleInputFocus('zipCode')}
                        />
                        {tipObj?.zipCode && (
                            <p className="msg">
                                {icon}
                                {tipObj?.zipCode === 1 ? t('zip_error') : t('zip_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list short required">
                        <input
                            className={`input ${tipObj?.address1 ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('address1')}*`}
                            value={formData?.address1}
                            onChange={(e: any) => handleInputChange(e, 'address1')}
                            onFocus={() => handleInputFocus('address1')}
                        />
                        {tipObj?.address1 && (
                            <p className="msg">
                                {icon}
                                {t('address1_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list short required">
                        <input
                            className={`input ${tipObj?.address2 ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('address2')}*`}
                            value={formData?.address2}
                            onChange={(e: any) => handleInputChange(e, 'address2')}
                            onFocus={() => handleInputFocus('address2')}
                        />
                        {tipObj?.address2 && (
                            <p className="msg">
                                {icon}
                                {t('address2_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list short required">
                        <input
                            className={`input ${tipObj?.address3 ? 'error' : ''}`}
                            type="text"
                            placeholder={`${t('address3')}*`}
                            value={formData?.address3}
                            onChange={(e: any) => handleInputChange(e, 'address3')}
                            onFocus={() => handleInputFocus('address3')}
                        />
                        {tipObj?.address3 && (
                            <p className="msg">
                                {icon}
                                {t('address3_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list">
                        <input
                            className="input"
                            type="text"
                            placeholder={`${t('address4')}`}
                            value={formData?.address4}
                            onChange={(e: any) => handleInputChange(e, 'address4')}
                            onFocus={() => handleInputFocus('address4')}
                        />
                    </li>
                    <li className="list list-title">{t('connection')}</li>
                    <li className="list radios">
                        <div className="radios-group">
                            <div className="input-radio">
                                <input
                                    type="radio"
                                    id="dp3-form-radio1"
                                    className="radio"
                                    checked={formData?.connectionMethod === t('connection_item1')}
                                    onChange={() => handleChangeRadio(t('connection_item1'))}
                                />
                                <label htmlFor="dp3-form-radio1" className="radio-label">
                                    {t('connection_item1')}
                                </label>
                            </div>
                            <div className="input-radio">
                                <input
                                    type="radio"
                                    id="dp3-form-radio2"
                                    className="radio"
                                    checked={formData?.connectionMethod === t('connection_item2')}
                                    onChange={() => handleChangeRadio(t('connection_item2'))}
                                />
                                <label htmlFor="dp3-form-radio2" className="radio-label">
                                    {t('connection_item2')}
                                </label>
                            </div>
                            <div className="input-radio">
                                <input
                                    type="radio"
                                    id="dp3-form-radio3"
                                    className="radio"
                                    checked={formData?.connectionMethod === t('connection_item3')}
                                    onChange={() => handleChangeRadio(t('connection_item3'))}
                                />
                                <label htmlFor="dp3-form-radio3" className="radio-label">
                                    {t('connection_item3')}
                                </label>
                            </div>
                        </div>
                        {tipObj?.connectionMethod && (
                            <p className="msg">
                                {icon}
                                {t('connection_tip')}
                            </p>
                        )}
                    </li>
                    <li className="list upload-img">
                        <div className={`load-img-box ${formData?.img?.length > 0 ? 'has-img' : 'no-img'}`}>
                            <Uploader
                                value={formData?.img || []}
                                maxCount={1}
                                size={5 * 1024 * 1024}
                                types={['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'jpg', 'jpeg', 'png', 'gif', 'webp']}
                                accept="image/*"
                                onChange={(urls) => {
                                    if (tipObj?.img) {
                                        setTipObj({ ...tipObj, img: false });
                                    }
                                    setFormData({ ...formData, img: urls });
                                }}
                            />
                        </div>
                        {tipObj?.img && (
                            <p className="msg">
                                {icon}
                                {tipObj === 1 ? t('img_error') : t('img_size')}
                            </p>
                        )}
                    </li>
                    <div className="memo-box">
                        <span className="memo-text">{t('img_memo')}</span>
                        <svg
                            className="memo-svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => setShowDialog(true)}
                        >
                            <path
                                d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
                                stroke="#F7A40A"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M7.575 7.5C7.77092 6.94306 8.15763 6.47342 8.66663 6.17428C9.17563 5.87513 9.77408 5.76578 10.356 5.86559C10.9379 5.96541 11.4657 6.26794 11.8459 6.71961C12.2261 7.17128 12.4342 7.74294 12.4333 8.33333C12.4333 10 9.93333 10.8333 9.93333 10.8333V12.0834"
                                stroke="#F7A40A"
                                strokeWidth="1.25"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path d="M10 14.1667H10.0083" stroke="#F7A40A" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <li className="list required">
                        <textarea
                            className={`input textarea ${tipObj?.content ? 'error' : ''}`}
                            rows={5}
                            placeholder={`${t('text')}*`}
                            value={formData?.content}
                            onChange={(e: any) => handleInputChange(e, 'content')}
                            onFocus={() => handleInputFocus('content')}
                        />
                        {tipObj?.content && (
                            <p className="msg">
                                {icon}
                                {t('text_tip')}
                            </p>
                        )}
                    </li>
                </ul>
                <p className="terms">
                    {t.rich('terms', {
                        b: (txt: string) => <span className="term-title">{txt}</span>,
                        a: (txt: string) => (
                            <a href="https://jp.ecoflow.com/pages/privacy-policy-2023" className="terms-link" target="_blank" rel="noreferrer">
                                {txt}
                            </a>
                        ),
                    })}
                </p>
                <div className="agreement">
                    <input id="dp3-quote-form-check" type="checkbox" className="checkbox" checked={formData?.agreed} onChange={handleCheckChange} />
                    <label className="agreement-text" htmlFor="dp3-quote-form-check">
                        {t('agreement')}
                    </label>
                    {tipObj?.agreed && (
                        <p className="msg">
                            {icon}
                            {t('agreement_tip')}
                        </p>
                    )}
                </div>
                {/* size: compact normal invisible */}
                <div className="g-recaptcha">
                    {/* @ts-ignore */}
                    <ReCAPTCHA ref={recaptchaRef} size={'normal'} sitekey={SECRET_KEY} hl={hl} onChange={onReCAPTCHAChange} />
                </div>
                <button className="submit" onClick={handleSubmit}>
                    {t('submit')}
                </button>
            </div>
            {isClient && showSuccess && createPortal(<Success text={t('success_text')} callback={() => setShowSuccess(false)} />, document.body)}
            {isClient && showDialog && createPortal(<Dialog callback={() => setShowDialog(false)} />, document.body)}
        </div>
    );
}
